<template>
  <div>
    <eg-search-select
      :items="classes"
      :value="selectedClass"
      title-key="name"
      entity="class"
      :placeholder="$t('classes.enterClassName')"
      :required="required"
      :submitted="submitted"
      show-create-entity
      hide-create-divider
      allow-custom-input
      :empty-title="$t('classes.createFirstClass')"
      @input="selectClass($event)"
    >
    </eg-search-select>
  </div>
</template>

<script>
import EgSearchSelect from "@/components/global/eg_search_select.vue";

export default {
  name: "FolderClassSelector",

  components: {
    EgSearchSelect,
  },

  inject: ["workspacesProvider"],

  props: {
    value: {
      type: Object,
      default: null,
    },
    classes: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    submitted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedClass: null,
    };
  },

  computed: {
    extractedData() {
      if (!this.workspacesProvider) {
        return { classes: [], assignments: [] };
      }
      return this.workspacesProvider.extractClassesAndAssignments();
    },
  },

  methods: {
    selectClass(selectedClass) {
      if (selectedClass) {
        this.selectedClass = selectedClass;
        this.$emit("input", selectedClass);
      }
    },
  },
};
</script>
